import styled from 'styled-components';
import { Paper } from '@material-ui/core';
import { diffuseGlass } from 'styles/mixins';

export const StyledZoomControlContainer = styled(Paper)<{
    $hasSelectedCountry: boolean;
    $isSmallScreen: boolean;
    $hideHeader: boolean;
}>`
    position: absolute;
    z-index: 200;
    display: flex;
    flex-direction: column;
    ${({ $hasSelectedCountry }) =>
        $hasSelectedCountry && `margin-right: 340px;`}
    ${({ $isSmallScreen, $hideHeader }) =>
        $isSmallScreen
            ? `
        top: ${$hideHeader ? '10px' : '56px'};
        left: 10px;
    `
            : `
        bottom: 20px;
        right: 20px;
    `}
    ${diffuseGlass}
`;

export const StyledDivider = styled.div`
    height: 1;
    background: 'rgba(0,0,0,0.12)';
`;
